<div class="w-100">
    <div class="d-flex">
        <img src="assets/images/user.png" style="width: 134px;height: 134px; cursor: pointer; border-radius: 50%; object-fit: cover;" alt="" *ngIf="!userProfile.photo_path" (click)="fileInputProfile.click()">
        <input #fileInputProfile id="fileInputProfile" type="file" style="display: none;" (change)="onFileSelectedProfilePhoto($event)">
        <img [src]="userProfile.photo_path" style="width: 134px;height: 134px; cursor: pointer; border-radius: 50%; object-fit: cover;" alt="" *ngIf="userProfile.photo_path" (click)="fileInputProfile.click()">
        <div style="margin-left: 2rem;margin-top: 1rem;font-size: 2rem;color: #0F0F1F;">
            <span>Hi,</span>
            <br />
            <span class="weight-500">{{userProfile.first_name + ' ' + userProfile.last_name}}</span>
        </div>
    </div>
    <div class="fm-rubik d-flex mt-5">
        <div class="col-md-6 mx-1">
            <span class="input-title">First name*</span>
            <div class="">
                <input [(ngModel)]="userProfile.first_name" type="text" class="p-2 input-promo w-100 weight-200"
                    placeholder="type here ..." />
            </div>
        </div>
        <div class="col-md-6 mx-1">
            <span class="input-title">Last name*</span>
            <div class="">
                <input [(ngModel)]="userProfile.last_name" type="text" class="p-2 input-promo w-100 weight-200"
                    placeholder="type here ..." />
            </div>
        </div>
    </div>
    <div class="fm-rubik d-flex mt-3">
        <div class="col-md-12 w-100 mx-2">
            <span class="input-title">Email*</span>
            <div class="">
                <input [(ngModel)]="userProfile.email" type="email" class="p-2 input-promo w-100 weight-200"
                    placeholder="type here ..." />
            </div>
        </div>
    </div>
    <div class="fm-rubik d-flex mt-3">
        <div class="col-md-12 w-100 mx-2">
            <span class="input-title">Phone number*</span>
            <div class="">
                <input [(ngModel)]="userProfile.phone_number" type="text" class="p-2 input-promo w-100 weight-200"
                    placeholder="type here ..." />
            </div>
        </div>
    </div>
    <button class="btn mt-4 weight-500 btn-apply" style="font-size: 1.143rem;color: #311C02;"(click)="updateProfile()">
        Update Profile
    </button>
    <button class="btn mt-4 weight-500 btn-apply" style="font-size: 1.143rem;color: #311C02;"(click)="openBillingDetails()">
        Update Billing Details
    </button>
    
</div>
